import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "flex"
};
import { generateColorMap } from "@/modules/vue/utils";
export default /*#__PURE__*/_defineComponent({
  __name: 'PlayerEnergy',
  props: {
    type: {
      default: 'icon'
    },
    player: null
  },
  setup(__props) {
    const props = __props;
    const rate = computed(() => Math.ceil(props.player.energy / 20));
    const colorClassMap = generateColorMap({
      text: 500
    });
    const color = computed(() => {
      return {
        5: ColorEnum.Green,
        4: ColorEnum.Lime,
        3: ColorEnum.Yellow,
        2: ColorEnum.Amber,
        1: ColorEnum.Red
      }[rate.value];
    });
    const icon = computed(() => {
      return {
        5: IconEnum.Battery920Regular,
        4: IconEnum.Battery720Regular,
        3: IconEnum.Battery520Regular,
        2: IconEnum.Battery320Regular,
        1: IconEnum.Battery120Regular
      }[rate.value];
    });
    return (_ctx, _cache) => {
      const _component_NProgress = _resolveComponent("NProgress");
      const _component_Icon = _resolveComponent("Icon");
      return __props.type === 'progress' ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_NProgress, {
        percentage: __props.player.energy,
        "show-indicator": false,
        color: _ctx.$colorValue(_unref(color), 500)
      }, null, 8, ["percentage", "color"])])) : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(["flex items-center justify-center", _unref(colorClassMap)[_unref(color)]])
      }, [_createVNode(_component_Icon, {
        icon: _unref(icon)
      }, null, 8, ["icon"])], 2));
    };
  }
});